const EMPHASIS_SECTIONS = [
  {
    key: 'history',
    className: 'report-emphasis-history',
    titlePattern: /对比上次检查数据/,
  },
  {
    key: 'summary',
    className: 'report-emphasis-summary',
    titlePattern: /整体评估/,
  },
  {
    key: 'followup',
    className: 'report-emphasis-followup',
    titlePattern: /复查计划/,
  },
]

function textOfHtml(html) {
  return String(html || '').replace(/<[^>]+>/g, '').replace(/\s+/g, '')
}

function findSectionEnd(html, fromIndex) {
  const nextHeadingPattern = /<h[1-3]\b[^>]*>/gi
  nextHeadingPattern.lastIndex = fromIndex
  const nextHeading = nextHeadingPattern.exec(html)
  if (nextHeading) return nextHeading.index

  const rootEnd = html.lastIndexOf('</div>')
  return rootEnd > fromIndex ? rootEnd : html.length
}

function wrapHeadingSection(html, section) {
  if (html.includes(section.className)) return html

  const headingPattern = /<h3\b[^>]*>[\s\S]*?<\/h3>/gi
  let match
  while ((match = headingPattern.exec(html)) !== null) {
    if (!section.titlePattern.test(textOfHtml(match[0]))) continue

    const start = match.index
    const end = findSectionEnd(html, headingPattern.lastIndex)
    return [
      html.slice(0, start),
      `<section class="report-emphasis ${section.className}">`,
      html.slice(start, end),
      '</section>',
      html.slice(end),
    ].join('')
  }

  return html
}

function enhanceReportEmphasis(html) {
  if (typeof html !== 'string') return ''
  return EMPHASIS_SECTIONS.reduce(
    (result, section) => wrapHeadingSection(result, section),
    html
  )
}

module.exports = {
  enhanceReportEmphasis,
}
